import app from "../Firebase/app";

export default async function isUserPremium() {
  await app.auth().currentUser.getIdToken(true);
  const decodedToken = await app.auth().currentUser.getIdTokenResult();
  return decodedToken.claims.stripeRole ? true : false;
}
